import React from 'react';
import { useFormField } from '../../core';
import { TimeSelector } from '@/ui-kit';
import { usePreFilledFieldValidation } from '../../hooks';

type InputTimeProps = {
  label: string;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
};

export const InputTime: React.FC<InputTimeProps> = ({ label, ...props }) => {
  const [field, meta] = useFormField<string>(props);

  const error = meta.touched ? meta.error : undefined;

  usePreFilledFieldValidation(field, meta.touched);

  // Destructure value to use generic type
  const { value, ...fieldProps } = field;

  return (
    <TimeSelector
      label={label}
      id={field.name}
      {...fieldProps}
      {...props}
      value={value}
      state={error ? 'error' : 'default'}
      stateText={error}
    />
  );
};
